(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-results-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (select && select.matches && select.matches('[data-rrf-country]') && select.form) {
      select.form.submit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-results-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      if (!root || root.getAttribute('data-rrr-ready')) return;
      root.setAttribute('data-rrr-ready', 'true');

      var track = root.querySelector('[data-rrr-track]');
      var dotsWrap = root.querySelector('[data-rrr-dots]');
      if (!track || !dotsWrap) return;

      var cards = Array.prototype.slice.call(track.children);
      if (cards.length < 2) return;

      function pad() {
        return parseFloat(getComputedStyle(track).paddingLeft) || 0;
      }

      var dots = cards.map(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'rrr__dot';
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: card.offsetLeft - pad(), behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        return dot;
      });

      var ticking = false;

      function update() {
        ticking = false;
        var left = track.scrollLeft;
        var atEnd = left + track.clientWidth >= track.scrollWidth - 2;
        var active = 0;
        var best = Infinity;

        if (atEnd) {
          active = cards.length - 1;
        } else {
          cards.forEach(function (card, i) {
            var diff = Math.abs(card.offsetLeft - pad() - left);
            if (diff < best) {
              best = diff;
              active = i;
            }
          });
        }

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === active);
          if (i === active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      track.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
          }
        },
        { passive: true }
      );
      window.addEventListener('resize', update);
      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-rrr]').forEach(initReviews);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
